









import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherUploadLogo from '../TedsLauncherUploadLogo/TedsLauncherUploadLogo.vue'
import TedsLauncherUpdateColors from '../TedsLauncherUpdateColors/TedsLauncherUpdateColors.vue'
@Component({
  components: {
    TedsLauncherUploadLogo,
    TedsLauncherUpdateColors,
  },
})
export default class TedsLauncherUiSettings extends Vue {}
